import React from 'react';

import Button from './Button';

const EditApplicationButton = ({ className, onClick }) => (
  <Button
    label='Edit Application'
    iconClassName='icon-pencil-orange'
    buttonClassName={className || '_height_30 _width_pc_100 _max_width_170 _font_size_16'}
    onClick={onClick}
  />
);

export default EditApplicationButton;



// WEBPACK FOOTER //
// ./src/app/Components/EditApplicationButton.jsx